/**
 * Flags the document once hydration completes, for e2e tests. Clicks before this are dropped.
 * `__vue_app__` is set on root mount, before the root Suspense resolves, so it is too early.
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:suspense:resolve', () => {
    document.documentElement.dataset.hydrated = 'true'
  })
})
